<div
  class="w-full bg-ui-bg px-sm py-base lg:hidden flex items-center justify-between"
  style="z-index: 1000"
>
  <div class="p-sm flex pt-sm cursor-pointer text-txt" (click)="openSideMenuBottomSheet('main')">
    <svg-icon
      [key]="openedBottomSheetType === 'main' ? 'close-light' : 'menu'"
      class="!text-lg"
    ></svg-icon>
  </div>

  <div class="grow-0 shrink-0 cursor-pointer" routerLink="/dashboard">
    <img src="assets/images/icons/logo-full-2.svg" class="h-[40px]" alt="Logo" />
  </div>

  <div class="p-sm flex cursor-pointer text-txt" (click)="openSideMenuBottomSheet('profile')">
    <svg-icon
      [key]="openedBottomSheetType === 'profile' ? 'close-light' : 'user'"
      class="!text-lg"
    ></svg-icon>
  </div>
</div>
